import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { journeyContinuationApi } from '../../api/journeyContinuationApi';
import {
  isContinuationSourceAbsent,
  isIdString,
  provenancePresentation,
} from '../group-trip/actualContinuationModel';
import '../group-trip/actual-continuation.css';

/**
 * 個人後續行程的來源標示。只有擁有者查詢；一般行程沒有來源（95165）時完全不顯示。
 * 不顯示請求代碼、指紋等內部欄位，也不暗示與揪團同步。
 */
export default function JourneyContinuationSourceNote({ journeyId, requesterRole }) {
  const [state, setState] = useState({ status: 'idle', source: null });
  const id = journeyId == null ? '' : String(journeyId);
  const enabled = requesterRole === 'OWNER' && isIdString(id)
    && typeof journeyContinuationApi.getContinuationSource === 'function';

  useEffect(() => {
    if (!enabled) {
      setState({ status: 'idle', source: null });
      return undefined;
    }
    let active = true;
    setState({ status: 'loading', source: null });
    Promise.resolve()
      .then(() => journeyContinuationApi.getContinuationSource(id))
      .then((payload) => {
        if (active) setState({ status: 'ready', source: provenancePresentation(payload) });
      })
      .catch((cause) => {
        if (!active) return;
        setState({ status: isContinuationSourceAbsent(cause) ? 'absent' : 'failed', source: null });
      });
    return () => { active = false; };
  }, [enabled, id]);

  if (state.status === 'failed') {
    return (
      <p className="journey-provenance journey-provenance__secondary" data-testid="journey-provenance-unavailable">
        暫時無法確認這份行程是否延續自揪團。
      </p>
    );
  }
  if (state.status !== 'ready' || !state.source) return null;
  const { source } = state;
  return (
    <aside className="journey-provenance" aria-label="行程來源" data-testid="journey-provenance">
      <p className="journey-provenance__label">延續自揪團</p>
      <p className="journey-provenance__secondary">
        {[source.startedAt ? `個人行程開始：${source.startedAt}` : '', source.createdAt ? `建立於 ${source.createdAt}` : '']
          .filter(Boolean).join(' · ')}
      </p>
      <p className="journey-provenance__secondary">這是獨立的個人行程，不會與揪團同步。</p>
      {source.groupActualPath ? <Link to={source.groupActualPath}>查看揪團的實際行程</Link> : null}
    </aside>
  );
}
